export default __webpack_public_path__ + "static/media/brainHealthStudio0.d5fb87be.png";